<template>
  <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_SelectLockOrderCondition')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :label-width="$selectByLang('90px', '90px', '90px', '150px', '150px', '150px')" label-position="left" @submit.native.prevent>
        <div>
          <el-form-item :label="$t('CargoMsg.Cargo_AuditDate')">
            <el-date-picker
              v-model="formData.verifyDate"
              no="verifyDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:251px;"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CreatedDate')">
            <el-date-picker
              v-model="formData.dateCreated"
              no="createdDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width:251px;"
              clearable
              :editable="false"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate')">
            <el-date-picker
              v-model="formData.businessDate"
              no="businessDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width:251px;"
              clearable
              :editable="false"
            />
          </el-form-item>
          <el-form-item :label="$t('queryJob.customer')">
            <cargo-advance-select
              no="customerIds"
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{customer:true}"
              :default-multiple-value="formData.customerIds"
              callback-method-type="value"
              :multiple="true"
              options-width="100px"
              style="width:251px;"
              @parentCallBack="value=>formData.customerIds=[...value]"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <!--多行文本，逗号隔开 multiText-->
            <cargo-multi-line-text-popover
              :show-popover="true"
              :value.sync="formData.jobNos"
              style="width:100%"
              :visible-arrow="false"
              :placeholder="' '"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
              :show-custom-label-in-option="true"
              :default-multiple-value="formData.lobs"
              callback-method-type="value"
              :multiple="true"
              style="width: 251px"
              @parentCallBack="value=>formData.lobs=[...value]"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button no="Confirm" type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoMultiLineTextPopover from '@/components/Cargo/Common/cargoMultiLineTextPopover'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES as selectTypeNames } from '@/utils/class/AdvanceSelect'
import { Assert } from '@/utils/validate'
import DateUtils from '@/utils/dateUtils'
import { countJobVerifyByRange } from '@/api/clearing/financeManage'
// import moment from 'moment'

export default {
  name: 'LockOrderDialog',
  components: { cargoAdvanceSelect, cargoMultiLineTextPopover },
  props: {
    visible: { type: Boolean, required: true },
    defaultJobNos: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames,
      innerVisible: this.visible,
      formData: {
        verifyDate: DateUtils.customFormat(new Date(), 'YYYY-MM-DD'),
        jobNos: this.defaultJobNos,
        customerIds: [],
        businessDate: [],
        dateCreated: [],
        lobs: []
      }
    }
  },
  computed: {
  },
  watch: {
    visible(val) {
      this.innerVisible = val
      if (val) {
        this.formData.jobNos = this.defaultJobNos || ''
      }
    },
    defaultJobNos(val) {
      this.formData.jobNos = val || ''
    }
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    async confirm() {
      await Assert.isNotBlank(this.formData.verifyDate, this.$t('CargoMsg.Cargo_PleaseSelectReviewDate'), 'warning')
      if (!this.formData.businessDate) this.formData.businessDate = []
      if (!this.formData.dateCreated) this.formData.dateCreated = []
      const hasLockCondition = this.formData.businessDate.length === 2 ||
        this.formData.dateCreated.length === 2 ||
        (this.formData.customerIds && this.formData.customerIds.length > 0) ||
        !!(this.formData.jobNos && this.formData.jobNos.trim()) ||
        (this.formData.lobs && this.formData.lobs.length > 0)
      await Assert.isTrue(hasLockCondition, this.$t('CargoMsg.Cargo_PSALOGODC2'), 'warning')
      const verifyDate = this.formData.verifyDate
      const customerIds = this.formData.customerIds || []
      let lobs = ''
      if (this.formData.lobs) {
        for (const p of this.formData.lobs) {
          if (lobs) {
            lobs += ','
          }
          lobs += p
        }
      }
      const param = { componet: this, accountingDate: verifyDate, customerIds, lobs, jobNos: this.formData.jobNos }
      if (this.formData.businessDate && this.formData.businessDate.length === 2) {
        param.bizStart = this.formData.businessDate[0] + ' 00:00:00'
        param.bizEnd = this.formData.businessDate[1] + ' 23:59:59'
      }
      if (this.formData.dateCreated && this.formData.dateCreated.length === 2) {
        param.dateCreatedStart = this.formData.dateCreated[0] + ' 00:00:00'
        param.dateCreatedEnd = this.formData.dateCreated[1] + ' 23:59:59'
      }
      param.branchId = this.$store.getters.currentOfficeId
      const { data: matchCount = 0 } = await countJobVerifyByRange({ ...param, componet: undefined })
      let isReturn = true
      await this.$confirm(`${this.$t('CargoMsg.Cargo_LockOrderTip')}<br/><br/>${this.$t('CargoMsg.Cargo_MatchedLockOrderCount', [matchCount])}`, this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
      }).catch(() => {
        isReturn = false
      })
      if (!isReturn) return
      this.$emit('confirm', param)
    }
  }
}
</script>

<style lang="scss">
</style>
